import { Component, OnInit } from '@angular/core';
import { ApplicationConstant } from 'src/app/application.constant';
import * as sectionDetails from 'src/assets/json/Resource.json';
import * as lookupResourceDetails from 'src/assets/json/LookupResource.json';
import { ContractType } from '../../../../shared/models/contract/contract-type.model';
import { SectionWiseService } from '../../../service/section-wise.service';
import { SwProcessStateService } from '../../../service/ui/sw-process-state.service';

@Component({
  selector: 'sw-process-container',
  templateUrl: './sw-process-container.component.html',
  host: {
    class: 'col-xs-12 col-sm-10 col-md-8 col-lg-6 col-sm-offset-1 col-md-offset-2 col-lg-offset-3 wcontainer',
    id: 'SectionContainer'
  }
})
export class SwProcessContainerComponent implements OnInit {
  contractType: ContractType = new ContractType();
  isLoading = true;

  constructor(
    public sectionWiseService: SectionWiseService,
    private swProcessStateService: SwProcessStateService
  ) {}

  ngOnInit() {
    this.sectionWiseService.sectionDetailsModel = (sectionDetails as any).default.SectionModel;
    ApplicationConstant.lookupResourceDetails = (lookupResourceDetails as any).default;
    this.getHealthContractDetails();
  }

  getHealthContractDetails() {
    this.swProcessStateService.swContractType$.subscribe((result) => {
      this.contractType = result;
      if (result.policyHolder.personType.length > 0) {
        this.isLoading = false;
      }
    });
  }
}
